import {
  createGroupActionButtons,
  createStatusTag,
  createStoreActionButtons,
  renderCategories,
  renderCoordinate,
  renderStoreImage,
} from "./storeConstants";

export const transformStoresToRowData = (
  stores,
  onEdit,
  onDelete,
  onView,
  isSyncMarket = false
) => {
  return stores.map((store) => ({
    image: renderStoreImage(store.imageUrl, store.name),
    storeId: store.metadata?.store_id || "-",
    name: store.name,
    retailer: store.metadata?.retailer || "-",
    city: store.metadata?.city || "-",
    state: store.metadata?.state || "-",
    district: store.metadata?.district || "-",
    postcode: store.metadata?.postcode || "-",
    country: store.metadata?.country || "-",
    latitude: renderCoordinate(store.metadata?.geolocation?.latitude),
    longitude: renderCoordinate(store.metadata?.geolocation?.longitude),
    category: renderCategories(
      store.categories?.length ? store.categories : [store.category].filter(Boolean)
    ),
    status: createStatusTag(store.status),
    actions: createStoreActionButtons(store, onEdit, onDelete, onView, isSyncMarket),
  }));
};

export const transformGroupsToRowData = (
  groups,
  onViewGroup,
  onEditGroup,
  onDeleteGroup
) => {
  return groups.map((group) => ({
    status: createStatusTag(group.status),
    name: group.name,
    storeCount: group.storeCount,
    actions: createGroupActionButtons(
      group.name,
      onViewGroup,
      onEditGroup,
      onDeleteGroup
    ),
  }));
};

export const STORE_EXPORT_CSV_HEADERS = [
  "Store Id",
  "Name",
  "Retailer",
  "Address",
  "Postcode",
  "City",
  "State",
  "Country",
  "Latitude",
  "Longitude",
  "Categories",
];

const escapeCsvField = (value) => {
  const str = value == null ? "" : String(value);
  return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

export const buildStoresCsv = (stores) => {
  const rows = stores.map((store) => {
    const metadata = store.metadata || {};
    const geo = metadata.geolocation || {};
    return [
      metadata.store_id,
      store.name,
      metadata.retailer,
      metadata.address,
      metadata.postcode,
      metadata.city,
      metadata.state,
      metadata.country,
      geo.latitude,
      geo.longitude,
      store.categories?.join("|") || "",
    ]
      .map(escapeCsvField)
      .join(",");
  });
  return [STORE_EXPORT_CSV_HEADERS.join(","), ...rows].join("\n");
};

export const downloadStoresCsv = (stores, filename = `stores-${Date.now()}.csv`) => {
  const blob = new Blob([buildStoresCsv(stores)], { type: "text/csv" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(link.href);
};
